var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('GlobTopNav',{attrs:{"title":_vm.datas.title}}),_vm._v(" "),_c('div',{staticClass:"van-content"},[_c('div',{staticClass:"newsbox"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.datas.content)}}),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time(_vm.datas.add_time)))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fff87fea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/mynews/news.vue
// module id = null
// module chunks = 